//#region src/webcomponents/pix-mail-message/locales/de-AT.json
var e = { "pix-mail-message": {
	actions: {
		blockSender: "Absender blockieren",
		delete: "Löschen",
		forward: "Transfer",
		markAsUnread: "Als ungelesen markieren",
		menu: "Menü",
		reply: "Antworten",
		reportSpam: "Als unerwünscht melden",
		return: "zurück"
	},
	details: "Details anzeigen",
	previousHeader: "Die {{ date }} unter {{time}}, {{ name }}",
	toMe: "An mich"
} }, t = { "pix-mail-message": {
	actions: {
		blockSender: "Block sender",
		delete: "Delete",
		forward: "Forward",
		markAsUnread: "Mark as unread",
		menu: "Menu",
		reply: "Reply",
		reportSpam: "Report as unwanted",
		return: "back"
	},
	details: "View details",
	previousHeader: "Visit {{ date }} at {{time}}, {{ name }}",
	toMe: "To me"
} }, n = {}, r = { "pix-mail-message": {
	actions: {
		blockSender: "Bloquear al remitente",
		delete: "Eliminar",
		forward: "Reenviar",
		markAsUnread: "Marcar como no leído",
		menu: "menú",
		reply: "Responder",
		reportSpam: "Informar como indeseable",
		return: "volver"
	},
	details: "Mostrar detalles",
	previousHeader: "Visite {{ date }} en {{time}}, {{ name }}",
	toMe: "A mí"
} }, i = { "pix-mail-message": {
	actions: {
		blockSender: "Bloquer l’expéditeur",
		delete: "Supprimer",
		forward: "Transférer",
		markAsUnread: "Marquer comme non lu",
		menu: "menu",
		reply: "Répondre",
		reportSpam: "Signaler comme indésirable",
		return: "Retour"
	},
	details: "Afficher les détails",
	previousHeader: "Le {{ date }} à {{time}}, {{ name }}",
	toMe: "À moi"
} }, a = { "pix-mail-message": {
	actions: {
		reply: "Répondre",
		forward: "Transférer",
		menu: "menu",
		delete: "Supprimer",
		blockSender: "Bloquer l’expéditeur",
		markAsUnread: "Marquer comme non lu",
		reportSpam: "Signaler comme indésirable",
		return: "Retour"
	},
	toMe: "À moi",
	details: "Afficher les détails",
	previousHeader: "Le {{ date }} à {{time}}, {{ name }}"
} }, o = { "pix-mail-message": {
	actions: {
		blockSender: "Bloccare il mittente",
		delete: "Cancellare",
		forward: "Trasferimenti",
		markAsUnread: "Segna come non letto",
		menu: "menu",
		reply: "Rispondi a",
		reportSpam: "Segnalazione come indesiderabile",
		return: "ritorna"
	},
	details: "Mostra i dettagli",
	previousHeader: "Visitate {{ date }} su {{time}}, {{ name }}",
	toMe: "Per me"
} }, s = {};
//#endregion
export { r as a, e as c, i, o as n, n as o, a as r, t as s, s as t };
